export class LicenseResultModel {
  SubscriptionRequired = true;
  CreditsRequired = true;
  RequiredCredits = 0;
  RequiredSubscription = 0;
  UserHasRequiredCredits = false;
  UserHasSubscription = false;
  UserIsLicensed = false;
  IsAdmin = false;
  IsLoggedIn = false;
  AvailableCredits = 0;
  SubscriptionPrice = 0;
  AdditionalInformation = '';
}
